export default function AdminWarningCard() {
  return (
    <div className="mb-5 rounded-2xl border border-amber-300 bg-amber-50 p-4">
      <div className="text-sm text-amber-900 font-medium">Admin action</div>
      <div className="text-sm text-amber-900/80 mt-1">
        This page should only be used by authenticated admins.
      </div>
    </div>
  );
}
